export default "__VITE_ASSET__C$NuemAQ__"